export const EVENT_TIME = 60;
export const FINISH_BY_TIME = false;
export const SHOW_EVENT_TIME = true;
export const STUDIOEVENT_PAGE_COUNT = 30;
export const STUDIOEVENT2_PAGE_COUNT = 30;
export const STUDIO_EVENT_WELCOME_MESSAGE = 'Codementum Competition!';
export const STUDIO_EVENT_EXIT_MESSAGE =
  "You've completed our Codementum Competition!";

/**
 *
 * Common utils for studio
 */
export class PageUtils {
  static getChallenge() {
    let hash = window.location.hash.replace('#/', '');

    return hash === '' || isNaN(hash) ? 0 : parseInt(hash);
  }

  /**
   * Tries to go to the challenge specified
   * @param  {number} challenge page number
   */
  static goToChallenge(challenge = '') {
    window.location = '#/' + challenge;
  }

  static isStudioPrimary() {
    if (PageUtils.isLocalhost()) {
      return window.studioType === 'studio';
    }

    return PageUtils.getSubdomain() === 'studio';
  }

  static isStudioSecondary() {
    if (PageUtils.isLocalhost()) {
      return window.studioType === 'studio2';
    }

    return PageUtils.getSubdomain() === 'studio2';
  }

  static isStudioEvent() {
    return (
      PageUtils.isStudioEventPrimary() || PageUtils.isStudioEventSecondary()
    );
  }

  static isStudioEventPrimary() {
    if (PageUtils.isLocalhost()) {
      return window.studioType === 'studioevent';
    }

    return (
      !PageUtils.isStudioPrimary() && !PageUtils.getSubdomain().endsWith('2')
    );
  }

  static isStudioEventSecondary() {
    if (PageUtils.isLocalhost()) {
      return window.studioType === 'studioevent2';
    }

    return (
      !PageUtils.isStudioSecondary() && PageUtils.getSubdomain().endsWith('2')
    );
  }

  static isPrimary() {
    return PageUtils.isStudioPrimary() || PageUtils.isStudioEventPrimary();
  }

  static isSecondary() {
    return PageUtils.isStudioSecondary() || PageUtils.isStudioEventSecondary();
  }

  static isLocalhost() {
    return location.href.includes('localhost');
  }

  static getStudioType() {
    if (PageUtils.isLocalhost()) {
      return window.studioType;
    }

    if (PageUtils.isStudioEventPrimary()) {
      return 'studioevent';
    }

    if (PageUtils.isStudioEventSecondary()) {
      return 'studioevent2';
    }

    return PageUtils.getSubdomain();
  }

  static isStudioEventChallengesCompletedWith3Stars(
    competition = {},
    totalStars = 0
  ) {
    if (PageUtils.isStudioEventSecondary()) {
      const pageCount = competition.event2PageCount || STUDIOEVENT2_PAGE_COUNT;
      return totalStars >= pageCount * 3;
    }

    if (PageUtils.isStudioEventPrimary()) {
      const pageCount = competition.eventPageCount || STUDIOEVENT_PAGE_COUNT;
      return totalStars >= pageCount * 3;
    }

    return false;
  }

  static isEndOfStudioEvent(competition = {}, totalSolutionCount = 0) {
    if (PageUtils.isStudioEventSecondary()) {
      const pageCount = competition.event2PageCount || STUDIOEVENT2_PAGE_COUNT;
      return totalSolutionCount >= pageCount;
    }

    if (PageUtils.isStudioEventPrimary()) {
      const pageCount = competition.eventPageCount || STUDIOEVENT_PAGE_COUNT;
      return totalSolutionCount >= pageCount;
    }

    return false;
  }

  static getSubdomain() {
    const sub = window.location.host.substr(
      0,
      window.location.host.indexOf('.')
    );
    return sub.replace(/^dev-/, '');
  }
}

export default PageUtils;
